var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 18.8128C14.5655 18.8128 11.7705 16.0178 11.7705 12.5837C11.7705 9.14949 14.5655 6.35449 17.9997 6.35449C21.4338 6.35449 24.2288 9.14949 24.2288 12.5837C24.2288 16.0178 21.4338 18.8128 17.9997 18.8128ZM17.9997 7.97949C15.4647 7.97949 13.3955 10.0487 13.3955 12.5837C13.3955 15.1187 15.4647 17.1878 17.9997 17.1878C20.5347 17.1878 22.6038 15.1187 22.6038 12.5837C22.6038 10.0487 20.5347 7.97949 17.9997 7.97949Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.306 29.6458C26.8618 29.6458 26.4935 29.2775 26.4935 28.8333C26.4935 25.0958 22.6802 22.0625 18.0002 22.0625C13.3202 22.0625 9.50684 25.0958 9.50684 28.8333C9.50684 29.2775 9.1385 29.6458 8.69434 29.6458C8.25017 29.6458 7.88184 29.2775 7.88184 28.8333C7.88184 24.2075 12.421 20.4375 18.0002 20.4375C23.5793 20.4375 28.1185 24.2075 28.1185 28.8333C28.1185 29.2775 27.7502 29.6458 27.306 29.6458Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserR);
export default __webpack_public_path__ + "static/media/UserR.241f70447f440ef6719fba78fc69b344.svg";
export { ForwardRef as ReactComponent };